module.exports = __webpack_public_path__ + "img/spot7.a2e1ffff.png";